import { Stack, useTheme } from '@mui/material';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { ErrorState } from 'src/components/error-state';

type Props = {
    className?: string;
};

export const HousekeepingError: FC<Props> = ({ className }) => {
    const { shadows, palette } = useTheme();
    const { t } = useTranslation();
    return (
        <Stack
            alignItems="stretch"
            className={className}
            css={{
                position: 'relative',
                color: 'inherit',
                textDecoration: 'none',
                background: palette.background.default,
                zIndex: 'auto',

                '::after': {
                    content: '""',
                    position: 'absolute',
                    zIndex: -1,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    top: 0,
                    boxShadow: shadows[1],
                },
            }}
            padding={{ xs: '32px 16px', md: '36px' }}
            gap="32px"
        >
            <ErrorState title={t('housekeeping_loading_error')} />
        </Stack>
    );
};
